<ng-template #templateRef>
    <form #editorForm="ngForm" name="editAddress" (ngSubmit)="save()" id="crmAddressEditor">
        <h2 mat-dialog-title>
            {{Copy && Copy.Id ? 'Edit' : 'New'}} Address
          <mat-icon *ngIf="Copy.ExternalId" class="text-right" matTooltip="Linked with SAP S4">insert_link</mat-icon>
          <app-creator-modifier-icon style="float: right; margin-right: 10px" [object]="Copy"></app-creator-modifier-icon>
        </h2>
        <mat-dialog-content *ngIf="Copy">
          <div *ngIf="!isValidated()" class="row mt-1">
            <div class="col-12">
              <p class="p-3 w-100 bg-warning msgbox">
                There were duplicate addresses found, please mark them one by one through the "Duplicates" tab. By marking them you confirm they aren't duplicates.
              </p>
            </div>
          </div>
          <mat-tab-group>
            <mat-tab label="General">
              <div *ngIf="!isAllowedToCreateAddress() && !Copy.Id" class="row">
                <div class="col-12 text-center">
                  <p class="w-100 p-2 bg-warning" style="border-radius: 5px;">It's not allowed to create addresses for this customer. Please contact masterdata to add addresses.</p>
                </div>
              </div>
              <div *ngIf="!isAllowedToCreateAddress() && Copy.Id" class="row">
                <div class="col-12 text-center">
                  <p class="w-100 p-2 bg-warning" style="border-radius: 5px;">It's not allowed adjust addresses for this customer. Please contact masterdata to adjust addresses.</p>
                </div>
              </div>
              <div class="row">
                <div *ngIf="!hideRelation" class="col-md-6">
                  <app-relation-selector [(ngModel)]="Copy.Relation" name="Relation" required></app-relation-selector>
                    </div>
                    <div [class.col-md-6]="!hideRelation" [class.col-12]="hideRelation">
                      <app-dropdown-option [(ngModel)]="Copy.Type" (ngModelChange)="check()" discriminator="Type" model="Address" name="Type"
                                           placeholder="Type" required></app-dropdown-option>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input [(ngModel)]="Copy.Name" [disabled]="Copy.Id && Copy.Type.Id !== 'd5b0344f-e908-4a59-953f-a9ae1bbbcaad'" matInput name="Name" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <mat-form-field>
                        <mat-label>E-mail</mat-label>
                        <input [(ngModel)]="Copy.Email" [required]="Copy.Type?.Id === '4870f240-1c60-46a2-af41-1b135e46b1ee'" email matInput name="Email">
                        <button (click)="Copy.Email = Copy.Relation.Email" *ngIf="Copy.Relation" mat-icon-button matIconSuffix matTooltip="Use address {{Copy.Relation.Email}}" type="button">
                          <mat-icon>person</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6">
                      <mat-form-field>
                        <mat-label>Phone Number</mat-label>
                        <input [(ngModel)]="Copy.PhoneNumber" [required]="Copy.Type?.Id === '4870f240-1c60-46a2-af41-1b135e46b1ee'" matInput name="PhoneNumber">
                        <button mat-icon-button matIconSuffix type="button">
                          <mat-icon>phone</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <app-dropdown-option [(ngModel)]="Copy.Currency" discriminator="Currency" model="Document" name="Currency"
                                           [required]="Copy.Type?.Id === '4870f240-1c60-46a2-af41-1b135e46b1ee'" placeholder="Currency"></app-dropdown-option>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-9">
                      <mat-form-field>
                        <mat-label>Street</mat-label>
                        <input (ngModelChange)="delayer.next()" [(ngModel)]="Copy.Street" matInput maxlength="60" name="Street" required>
                      </mat-form-field>
                    </div>
                    <div class="col-md-3">
                      <mat-form-field>
                        <mat-label>Nr.</mat-label>
                        <input (ngModelChange)="delayer.next()" [(ngModel)]="Copy.Number" matInput maxlength="10" name="Number" required
                               type="text">
                      </mat-form-field>
                    </div>
                    <div *ngIf="false" class="col-md-3">
                      <mat-form-field>
                        <mat-label>Bus</mat-label>
                        <input [(ngModel)]="Copy.BusNumber" matInput name="BusNumber">
                      </mat-form-field>
                    </div>
                  </div>
                    <div class="row">
                      <div class="col-md-4">
                        <mat-form-field>
                          <mat-label>Postal code</mat-label>
                          <input (ngModelChange)="delayer.next()" [(ngModel)]="Copy.Postcode" matInput name="Postcode"
                                 [pattern]="Copy.Country?.PostcodePattern" required>
                          <mat-hint *ngIf="Copy.Country?.PostcodePattern">ISO format of {{Copy.Country?.IsoCode}}
                            <ng-container *ngIf="Copy.Country?.PostcodeExample">, e.g.: {{Copy.Country?.PostcodeExample}}</ng-container>
                          </mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="col-md-4">
                        <mat-form-field>
                          <mat-label>City</mat-label>
                          <input (ngModelChange)="delayer.next()" [(ngModel)]="Copy.City" matInput maxlength="40" name="City" required>
                        </mat-form-field>
                      </div>
                      <div class="col-md-4">
                        <app-country-selector [(ngModel)]="Copy.Country" [required]="true" name="Country"
                                              placeholder="Country"></app-country-selector>
                      </div>
                    </div>
                  <div class="row">
                    <div class="col-12">
                      <app-dropdown-option [(ngModel)]="Copy.SupplyPlant" [required]="Copy.Type?.Id === '4870f240-1c60-46a2-af41-1b135e46b1ee'" discriminator="SupplyPlant" model="Address"
                                           name="SupplyPlant"
                                           placeholder="SupplyingPlant"></app-dropdown-option>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <app-dropdown-option [(ngModel)]="Copy.CarrierServiceLevel" discriminator="CarrierServiceLevel" model="Address" name="CarrierServiceLevel"
                                           placeholder="CarrierServiceLevel" disabled></app-dropdown-option>
                    </div>
                    <div class="col-md-6">
                      <app-dropdown-option [(ngModel)]="Copy.CarrierServiceLevelOther" discriminator="CarrierServiceLevelOther" model="Address" name="CarrierServiceLevelOther"
                                           placeholder="CarrierServiceLevelOther" disabled></app-dropdown-option>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <mat-form-field>
                        <mat-label>Shipping Info</mat-label>
                        <textarea [(ngModel)]="Copy.ShippingInfo" matInput name="ShippingInfo"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div [class]="Copy.Type?.Id !== 'd5b0344f-e908-4a59-953f-a9ae1bbbcaad' ? 'col-md-6' : 'col-12'">
                      <mat-checkbox name="IsActive" [disabled]="Copy.Type?.Id === '4870f240-1c60-46a2-af41-1b135e46b1ee'"
                                    [(ngModel)]="Copy.IsActive"> Active
                      </mat-checkbox>
                      <p *ngIf="Copy.Type?.Id === '4870f240-1c60-46a2-af41-1b135e46b1ee'" style="font-size: 0.8em;">If not checked, it is <strong>not possible to enter SalesOrders</strong> on this address.</p>
                      <p *ngIf="Copy.Type?.Id === 'd5b0344f-e908-4a59-953f-a9ae1bbbcaad'" style="font-size: 0.8em;">If checked, the address <strong>will be visible</strong> on the google maps <strong>in case
                        the geolocation is valid</strong>. Only addresses of type Google
                        Maps will be shown.</p>
                    </div>
                    <div *ngIf="Copy.Type?.Id !== 'd5b0344f-e908-4a59-953f-a9ae1bbbcaad'" class="col-md-6">
                      <mat-checkbox [(ngModel)]="Copy.IsDefault" name="IsDefault"> Default</mat-checkbox>
                      <p style="font-size: 0.8em;">If checked, the address <strong>will be selected by default</strong> on a salesOrder or in the reseller checkout.</p>
                    </div>
                  </div>
                </mat-tab>
              <mat-tab *ngIf="Copy.AddressLine1" label="Address lines">
                <div class="row">
                  <div class="col-md-12">
                    <mat-form-field>
                      <mat-label>Address Line 1</mat-label>
                      <input [(ngModel)]="Copy.AddressLine1" matInput name="AddressLine1">
                    </mat-form-field>
                  </div>
                  <div class="col-md-12">
                    <mat-form-field>
                      <mat-label>Address Line 2</mat-label>
                      <input [(ngModel)]="Copy.AddressLine2" matInput name="AddressLine2">
                    </mat-form-field>
                  </div>
                  <div class="col-md-12">
                    <mat-form-field>
                      <mat-label>Address Line 3</mat-label>
                      <input [(ngModel)]="Copy.AddressLine3" matInput name="AddressLine3">
                    </mat-form-field>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Opening Hours">
                <div class="row" *ngIf="Copy.OpeningHours; else noOpeningHours">
                  <div class="col-md-12">
                    <table class="mat-mdc-table">
                      <tr>
                        <th>Day</th>
                        <th>Open</th>
                        <th>From</th>
                        <th>Till</th>
                                    <th>From</th>
                                    <th>Till</th>
                                    <th style="width: 40px;"></th>
                                </tr>
                                <tbody>
                                <tr *ngFor="let key of Copy.OpeningHours?.getKeys(); let i = index">
                                    <ng-container *ngIf="Copy.OpeningHours[key] && Copy.OpeningHours[key].pauze">
                                        <td>{{key}}</td>
                                        <td>
                                            <button mat-button mat-raised-button type="button" (click)="Copy.OpeningHours[key].open = !Copy.OpeningHours[key].open">{{Copy.OpeningHours[key].open ? 'Open' :
                                                'Closed'}}
                                            </button>
                                        </td>
                                        <td>
                                            <mat-form-field>
                                              <mat-label>From</mat-label>
                                                <input matInput type="time" name="From{{key}}" [required]="Copy.OpeningHours[key].open" [(ngModel)]="Copy.OpeningHours[key].from">
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field>
                                              <mat-label>Pauze from</mat-label>
                                                <input matInput type="time" name="PauzeFrom{{key}}" [(ngModel)]="Copy.OpeningHours[key].pauze.from">
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field>
                                              <mat-label>Till</mat-label>
                                                <input matInput type="time" name="Till{{key}}" [(ngModel)]="Copy.OpeningHours[key].pauze.till">
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field>
                                              <mat-label>Pauze till</mat-label>
                                                <input matInput type="time" name="PauzeTill{{key}}" [required]="Copy.OpeningHours[key].open" [(ngModel)]="Copy.OpeningHours[key].till">
                                            </mat-form-field>
                                        </td>
                                        <td style="width: 40px;">
                                            <button *ngIf="i > 0" mat-icon-button (click)="copyHours(key)" type="button" matTooltip="Copy previous row">
                                                <mat-icon>subdirectory_arrow_left</mat-icon>
                                            </button>
                                        </td>
                                    </ng-container>
                                </tr>
                                </tbody>
                            </table>
                  </div>
                </div>
                <ng-template #noOpeningHours>
                  <div class="row">
                    <div class="col-sm-12">
                      <button mat-button mat-raised-button (click)="addOpeningHours()" type="button">Add Opening Hours</button>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
            <mat-tab *ngIf="duplicates.length > 0" label="Duplicates ({{duplicates.length}})">
              <table class="mat-mdc-table" style="width: 100%;">
                <tr>
                  <th style="text-align: left">Type</th>
                  <th style="text-align: left">Relation</th>
                  <th style="text-align: left">Address</th>
                  <th style="text-align: center">Not a duplicate</th>
                </tr>
                <tbody>
                <tr *ngFor="let duplicate of duplicates">
                  <td style="text-align: left">{{duplicate.address.Type?.Value}}</td>
                  <td style="text-align: left">
                    {{duplicate.address?.Relation?.Code}}
                    <br/>{{duplicate.address?.Relation?.Name}}
                  </td>
                  <td style="text-align: left">
                    {{duplicate.address.Street}} {{duplicate.address.Number}}
                    <br/>{{duplicate.address.Postcode}} {{duplicate.address.City}}
                    <br/>{{duplicate.address.Country?.Name}}
                  </td>
                  <td style="text-align: center;">
                    <mat-checkbox [(ngModel)]="duplicate.validated" name="Validated"></mat-checkbox>
                  </td>
                </tr>
                </tbody>
              </table>
            </mat-tab>
          </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button mat-button mat-raised-button [mat-dialog-close]="true">Close</button>
          <app-button [disabled]="!editorForm.form.valid || !isAllowedToCreateAddress() || !isValidated() || !checkedForDuplicates" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>

</ng-template>
